/****************************************************************
 スクロールバーを含めないViewport Width
****************************************************************/
const setVw = function () {
  const vw = document.documentElement.clientWidth / 100;
  document.documentElement.style.setProperty("--vw", `${vw}px`);
};
window.addEventListener("DOMContentLoaded", setVw);
window.addEventListener("resize", setVw);

// header/footer 読み込み
let loadedCount = 0;
function onPartLoaded() {
  loadedCount++;
  if (loadedCount === 2) applyScale();
}

// FAQ アコーディオン
$(".faq_contents .faq dt").on("click", function () {
  $(this).toggleClass("open");
  $(this).next().slideToggle(400, function () {
    // アニメーション完了後に高さを再計算
    if (typeof window.applyScale === "function") {
      window.applyScale();
    }
  });
});



// スムーススクロール
$(function () {
  $('a[href^="#"]').click(function () {
    var speed = 500;
    var href = $(this).attr("href");
    var target = $(href == "#" || href == "" ? "html" : href);
    var position = target.offset().top;
    $("html, body").animate({ scrollTop: position }, speed, "swing");
    return false;
  });
});



// fixed-navigation の表示制御
$(window).on("load scroll", function () {
  let reasonBottom = $(".reason").offset().top + $(".reason").outerHeight();
  let triggerPoint = reasonBottom - $(window).height();

  // フッターの上端を取得
  let footerTop = $("#shopify-section-footer").offset().top;
  let hidePoint = footerTop - $(window).height();

  if ($(window).scrollTop() >= triggerPoint && $(window).scrollTop() < hidePoint) {
    $(".fixed-navigation").fadeIn(400);
  } else {
    $(".fixed-navigation").fadeOut(400);
  }
});



// 画像切り替え
document.querySelectorAll("img[data-switch]").forEach((img) => {
  const images = [img.src, ...img.dataset.switch.split(",")];
  const durations = img.dataset.duration
    ? img.dataset.duration.split(",").map(Number)
    : [];

  const getDuration = (i) =>
    durations[i] ?? durations[durations.length - 1] ?? 1500;

  let index = 0;

  const next = () => {
    index = (index + 1) % images.length;
    img.src = images[index];
    setTimeout(next, getDuration(index));
  };

  setTimeout(next, getDuration(0));
});

(function () {
  const baseWidth = 1920;

  function applyScale() {
    const wrapper = document.querySelector(".fd-wrapper");

    if (window.innerWidth >= 768) {
      // リセットして自然な高さを計測
      wrapper.style.transform = "";
      wrapper.style.width = `${baseWidth}px`;
      wrapper.style.height = "";
      document.documentElement.style.height = "";
      document.body.style.height = "";

      const naturalHeight = wrapper.offsetHeight;
      const scale = document.documentElement.clientWidth / baseWidth;
      const scaledHeight = naturalHeight * scale;

      wrapper.style.transformOrigin = "top left";
      wrapper.style.transform = `scale(${scale})`;

      // ★ wrapper 自身の高さも縮小後に合わせて固定
      wrapper.style.height = `${naturalHeight}px`;  // transform前の高さを固定
      
      // wrapper を包む親要素の高さをscaledHeightに
      document.documentElement.style.height = "";
      document.body.style.height = "";
      
      // wrapperの親にheightをセット
      if (wrapper.parentElement) {
        wrapper.parentElement.style.height = `${scaledHeight}px`;
      }

    } else {
      wrapper.style.transform = "";
      wrapper.style.width = "";
      wrapper.style.height = "";
      if (wrapper.parentElement) {
        wrapper.parentElement.style.height = "";
      }
      document.documentElement.style.height = "";
      document.body.style.height = "";
    }
  }

  // グローバルに公開（header/footer 読み込み完了後にも呼べるように）
  window.applyScale = applyScale;

  window.addEventListener("load", function () {
    applyScale();
    setTimeout(applyScale, 500); // .load() の完了保険
  });
  window.addEventListener("resize", applyScale);
})();

const waitForRoot = () => {
  const root = document.querySelector('#ch-plugin-entry');

  if (!root) {
    requestAnimationFrame(waitForRoot);
    return;
  }

  const getShadow = () => root.querySelector(':scope > div')?.shadowRoot;

  const applyStyle = () => {
    const shadow = getShadow();
    if (!shadow) return;

    const launcher = shadow.querySelector('[data-ch-testid="launcher"]');
    const popup = launcher?.nextElementSibling;

    const nav = document.querySelector('.fixed-navigation');
    const isMobile = window.matchMedia('(max-width: 767px)').matches;

    let navHeight = 0;
    let navWidth = 0;
    let isNavVisible = false;

    if (nav) {
      const rect = nav.getBoundingClientRect();
      const style = getComputedStyle(nav);

      navHeight = rect.height;
      navWidth = rect.width;

      isNavVisible =
        style.display !== 'none' &&
        style.visibility !== 'hidden' &&
        parseFloat(style.opacity) > 0 &&
        rect.height > 0;
    }

    const OFFSET = 24;

    const adjust = (el) => {
      if (!el) return;

      if (isMobile) {
        el.style.setProperty('right', '', '');
        el.style.setProperty('left', '', '');
        el.style.setProperty(
          'bottom',
          isNavVisible ? `${navHeight + OFFSET}px` : '24px',
          'important'
        );
      } else {
        el.style.setProperty('left', '', '');
        el.style.setProperty('bottom', '', '');
        el.style.setProperty(
          'right',
          isNavVisible ? `${navWidth + OFFSET}px` : '24px',
          'important'
        );
      }
    };

    adjust(launcher);

    if (popup && popup.getAttribute('role') === 'dialog') {
      adjust(popup);

      if (popup && popup.getAttribute('role') === 'dialog') {
        adjust(popup);

        const backdrop = popup.querySelector('[class*="BackdropGradient"]');

        if (backdrop) {
          if (isMobile && isNavVisible) {
            backdrop.style.setProperty(
              'transform',
              `translateY(${navHeight + OFFSET}px)`,
              'important'
            );
          } else {
            backdrop.style.transform = '';
          }
        }
      }
    }
  };

  let intervalId;

  const waitForShadow = () => {
    const shadow = getShadow();

    if (!shadow) {
      requestAnimationFrame(waitForShadow);
      return;
    }

    // 初回
    applyStyle();

    // Shadow監視（Shopify再描画対策）
    const observer = new MutationObserver(applyStyle);
    observer.observe(shadow, { childList: true, subtree: true });

    // リサイズ
    let timeout;
    window.addEventListener('resize', () => {
      clearTimeout(timeout);
      timeout = setTimeout(applyStyle, 100);
    });

    // スクロール（ナビ表示トリガー）
    window.addEventListener('scroll', () => {
      requestAnimationFrame(applyStyle);
    });

    // ⭐ 強制維持（Shopify上書き対策）
    if (!intervalId) {
      intervalId = setInterval(applyStyle, 500);
    }
  };

  waitForShadow();
};

waitForRoot();